import React, { useState } from 'react';
import { isArray } from 'lodash';
import useFieldHelper from './fieldHelper';
import { FieldProps } from './types';
import { useUiTheme } from 'framework/uiTheme';
import { Button } from '../mui-builder/Button/Button';

export interface ExpandingFieldProps extends FieldProps {
  maxValueLength?: number;
  children: React.ReactElement;
}

const ExpandingField = ({ maxValueLength = 78, children, ...props }: ExpandingFieldProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const { getValue } = useFieldHelper(props);
  const value = getValue();
  const { Button: ThemedButton = Button } = useUiTheme();
  const shortValue = isArray(value) ? value?.slice(0, maxValueLength) : `${value?.slice(0, maxValueLength).trim()}...`;

  const toggleVisibility = (e: any) => {
    e.target.blur();
    setIsVisible(prev => !prev);
  };

  if (!value || value?.length <= maxValueLength) {
    return children;
  }

  return (
    <>
      {React.cloneElement(children, {
        ...props,
        value: isVisible ? value : shortValue,
      })}
      <ThemedButton color="primary" size="small" sx={{ lineHeight: 1 }} onClick={toggleVisibility}>
        {isVisible ? 'Hide' : 'Show'}
      </ThemedButton>
    </>
  );
};

export default ExpandingField;
